<template>
    <div class="rd-view">
        <template v-if="assignedRoutine">
            <div class="rd-topbar">
                <back-button :route="backRoute" />
            </div>
            <pre-assigned-routine v-if="!hasPreAssignedRoutineData" @complete="onCompletePreAssignedRoutine"
                :assignedRoutineId="assignedRoutineId" :coach-id="coachId" :questionnaireId="questionnaireId" />
            <assigned-routine-detail v-else-if="!showPostAssignedRoutine" @complete="onCompleteAssignedRoutine"
                :assignedRoutineId="assignedRoutineId" :readonly="hasPostAssignedRoutineData" show-complete-sets
                @showSummary="showSummary" />
            <post-assigned-routine v-else @finish="onFinishAssignedRoutine" :assignedRoutineId="assignedRoutineId"
                :coach-id="coachId" ref="post" />
        </template>
        <summary-assigned-routine-dialog :back-button="showBackBtn" @hide="onHideSummary"
            :assignedRoutineId="assignedRoutineId" ref="summary" />
    </div>
</template>

<script>

import { db, withAuthRetry } from "@/utils/Firebase";
import { getMergedBlocks } from "@/utils/Exercises";
import { mapMutations, mapState } from 'vuex'
import PreAssignedRoutine from "@/components/student/PreAssignedRoutine";
import AssignedRoutineDetail from '@/components/common/routines/AssignedRoutineDetail'
import PostAssignedRoutine from "@/components/student/PostAssignedRoutine";
import SummaryAssignedRoutineDialog from "@/components/student/SummaryAssignedRoutineDialog";
import BackButton from "@/components/common/BackButton";

export default {
    components: {
        BackButton,
        PreAssignedRoutine,
        AssignedRoutineDetail,
        PostAssignedRoutine,
        SummaryAssignedRoutineDialog,
    },
    data() {
        return {
            loading: false,
            assignedRoutine: null,
            showBackBtn: false,
        }
    },
    computed: {
        ...mapState(['currentRoutine']),
        assignedRoutineId(vm = this) {
            return vm.$route.params.uid
        },
        questionnaireId(vm = this) {
            return vm.assignedRoutine?.assignedQuestionnaireId || null
        },
        hasPreAssignedRoutineData(vm = this) {
            return !!(vm.assignedRoutine?.advance?.pre)
        },
        hasPostAssignedRoutineData(vm = this) {
            return !!(vm.assignedRoutine?.advance?.post)
        },
        hasCompleteRoutine(vm = this) {
            if (vm.currentRoutine) {
                let qtyExercises = 0
                let completed = 0;
                (vm.currentRoutine.blocks || []).forEach(block => {
                    let exercises = (block.exercises || []).filter(ex => ex.type !== 'rest').length
                    if (block.completed) {
                        qtyExercises += exercises
                        completed += exercises
                    } else qtyExercises += exercises
                })
                let result = parseInt((completed * 100) / qtyExercises) || 0
                return result === 100
            }
            return false
        },
        showPostAssignedRoutine(vm = this) {
            if (!vm.hasPostAssignedRoutineData && vm.hasCompleteRoutine) {
                vm.setTitle('routines.last_step')
                return true
            } else {
                return false
            }
        },
        coachId(vm = this) {
            return vm.currentRoutine?.coachId || vm.assignedRoutine?.coachId || null
        },
        backRoute(vm = this) {
            let route = { name: 'student.routines' }
            let date = vm.currentRoutine?.rawDate?.full || vm.assignedRoutine?.rawDate?.full || null
            if (!date) return route
            route.query = { date: date }
            return route
        }
    },
    async mounted() {
        const vm = this
        vm.$root.$on('assignedRoutineGone', vm.onAssignedRoutineGone)
        await vm.loadAssignedRoutine()
        if (!vm.hasPreAssignedRoutineData) vm.setTitle('routines.lets_start')
    },
    beforeDestroy() {
        this.$root.$off('assignedRoutineGone', this.onAssignedRoutineGone)
    },
    methods: {
        ...mapMutations(['setCurrentRoutine', 'setTitle', 'setCurrentCarousel']),
        async loadAssignedRoutine() {
            const vm = this
            await vm.withLoading(async () => {
                let assignedRoutineRef = await withAuthRetry(() => db.collection('assignedRoutines').doc(vm.assignedRoutineId).get())
                const data = assignedRoutineRef.data()
                if (!data || data.studentId !== vm.currentUser?.uid) {
                    vm.replaceRoute({ name: 'student.routines' })
                    return
                }
                vm.assignedRoutine = data
                vm.setCurrentRoutine({ ...data, blocks: await getMergedBlocks(data.blocks || []) })
            })
        },
        onAssignedRoutineGone(assignedRoutineId) {
            const vm = this
            if (assignedRoutineId !== vm.assignedRoutineId) return
            vm.replaceRoute(vm.backRoute)
        },
        async onCompletePreAssignedRoutine() {
            const vm = this
            await vm.loadAssignedRoutine()
            vm.toast(vm.$t('routines.data_saved'))
        },
        onCompleteAssignedRoutine() {
            const vm = this
            if (!vm.hasPostAssignedRoutineData) vm.toast(vm.$t('routines.complete'))
            vm.loadAssignedRoutine()
        },
        onFinishAssignedRoutine() {
            const vm = this
            vm.$refs.summary.show()
        },
        onHideSummary() {
            const vm = this
            if (vm.$refs.post) vm.$refs.post.loadingContent = true
        },
        showSummary() {
            const vm = this
            vm.showBackBtn = true
            vm.$refs.summary.show()
        }
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        vm.setCurrentRoutine()
        vm.setCurrentCarousel()
        vm.setTitle()
        next()
    }
}
</script>

<style scoped>
.rd-view {
    overflow-x: clip;
}

.rd-topbar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    margin-bottom: 12px;
}
</style>